<template>
  <div class="menu" data-build="v4">
    <ul class="menu__container">
      <li
        class="menu__item"
        v-for="(item, index) in localizedMenu"
        :key="index"
      >
        <router-link
          :to="item.to"
          class="menu__link"
          active-class="menu__link--active"
        >
          {{ item.label }}
        </router-link>
      </li>
    </ul>

    <b-icon
      icon="x"
      class="close-icon d-block d-lg-none"
      @click="$emit('menu-close')"
    ></b-icon>

    <header-right class="d-none d-lg-flex" />
  </div>
</template>

<script>
import HeaderRight from "./HeaderRight.vue";

const LEGACY_BY_ID = {
  1: "/about",
  2: "/services",
  3: "/career",
  4: "/partners",
  5: "/contact",
  6: "/faq",
  7: "/get-employee",
};

export default {
  components: { HeaderRight },
  data() {
    return {
      menus: [],
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    localizedMenu() {
      console.log("[HeaderMenu v4] computing, menus count:", this.menus.length);

      var field = "description_" + this.lang;
      var role = this.$store.getters["auth/role"]; // "" / "Clinic" / "Nurse"
      var self = this;
      var visible = this.menus.filter(function (m) {
        if (m.isActive === false) return false;
        // Per-user-type visibility (default true for legacy rows without these fields)
        if (role === "Clinic" && m.visibleForClinic === false) return false;
        if (role === "Nurse" && m.visibleForNurse === false) return false;
        if (!role && m.visibleForGuest === false) return false;
        return true;
      });

      var sorted = visible.slice().sort(function (a, b) {
        var oa = a.orderIndex || 0;
        var ob = b.orderIndex || 0;
        if (oa !== ob) return oa - ob;
        return (a.id || 0) - (b.id || 0);
      });

      var result = [];

      for (var i = 0; i < sorted.length; i++) {
        var item = sorted[i];

        // Yalnız cari dildə mətn varsa göstər. Boşdursa, bu menu cari dildə gizlənir.
        var rawLabel = item[field];
        var label = rawLabel && typeof rawLabel === "string" ? rawLabel.trim() : "";
        if (!label) {
          continue;
        }

        var to = "/";
        var source = "default";

        if (item.path && typeof item.path === "string" && item.path.trim().length > 0) {
          var p = item.path.trim();
          to = p.charAt(0) === "/" ? p : "/" + p;
          source = "backend-path";
        } else if (LEGACY_BY_ID[item.id]) {
          to = LEGACY_BY_ID[item.id];
          source = "legacy-id-" + item.id;
        }

        if (self.lang === "de" && to === "/career") {
          to = "/get-employee";
          source = source + "+de-override";
        }

        console.log("[HeaderMenu v4] item:", {
          id: item.id,
          rawPath: item.path,
          label: label,
          to: to,
          source: source,
        });

        if (label) {
          result.push({ id: item.id, label: label, to: to });
        }
      }

      return result;
    },
  },
  async mounted() {
    console.log("[HeaderMenu v4] MOUNTED");
    var ok = await this.$store.dispatch("headerMenus/getHeaderMenus");
    if (ok) {
      this.menus = this.$store.getters["headerMenus/allMenus"];
      console.log("[HeaderMenu v4] menus loaded:", this.menus);
    }
  },
};
</script>
